import { render, staticRenderFns } from "./holiday-tag.vue?vue&type=template&id=6d5c41c2&"
import script from "./holiday-tag.vue?vue&type=script&lang=js&"
export * from "./holiday-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports